document.querySelectorAll('.tabs').forEach((wrap) => {
  const tabClick = ({ target }) => {
    const { dataset: { id = '' } } = target;
    wrap.querySelectorAll('.tabs__tab').forEach(t => t.classList.remove('tabs__tab--selected'));
    target.classList.add('tabs__tab--selected');
    wrap.querySelectorAll('.tabs__panel').forEach(t => t.classList.add('tabs__panel--hidden'));
    wrap.querySelector(`#${id}`).classList.remove('tabs__panel--hidden');
  };

  const bindTabs = () => {
    wrap.querySelectorAll('.tabs__tab').forEach((tab) => {
      tab.addEventListener('click', tabClick);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindTabs();
  });
});
